module.exports = __webpack_public_path__ + "static/img/Gameknight-1.79e8461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameknight/imgs/Gameknight-1.png
// module id = 1816
// module chunks = 0